/**
 * @description 投资模块 API
 */
const prefix = process.env.VUE_APP_API_DATAS
export default ({ request }) => ({
  // 关于模块信息集合
  companyIntroduce(params = {}) {
    return request({
      url: `${prefix}/companyIntroduce`,
      method: 'get',
      params
    })
  },
  // 发展历程
  history(params = {}) {
    return request({
      url: `${prefix}/history`,
      method: 'get',
      params
    })
  },
  // 核心团队Banner
  coreTeamBanner(params = {}) {
    return request({
      url: `${prefix}/coreTeamBanner`,
      method: 'get',
      params
    })
  },
  // 核心团队Banner
  coreTeams(params = {}) {
    return request({
      url: `${prefix}/coreTeams`,
      method: 'get',
      params
    })
  },
  // 核心优势
  coreAdvantages(params = {}) {
    return request({
      url: `${prefix}/coreAdvantages`,
      method: 'get',
      params
    })
  },
  // 奖项荣誉
  honors(params = {}) {
    return request({
      url: `${prefix}/honors`,
      method: 'get',
      params
    })
  },
})
